import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import styles from "./LinkAccountsModal.module.css";

const LinkAccountsModal = ({ show, close }) => {
  const listItems = [
    "Previous email address",
    "Previous username",
    "New email address",
    "New username",
  ];
  return (
    <Modal
      type="alert"
      title="Link Accounts"
      id="Link Accounts"
      cancelText="Close"
      cancelButtonColor="blue"
      show={show}
      onClose={close}
      style={{ maxWidth: "90%", width: "625px", position: "fixed" }}
      focusOnClose="openLinkAccountButton"
    >
      <Text wrapper="h1" type="header" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
        Link user accounts
      </Text>
      <Text wrapper="p" type="body">
        If you have recently undergone a change of name, you will need to link your old iPerform
        account to your new one in order to see all previous information.
      </Text>
      <Text wrapper="p" type="body">
        Please email{" "}
        <a
          href="mailto:DigitalFactory@networkrail.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          DigitalFactory@networkrail.co.uk
        </a>{" "}
        with the following information:
      </Text>
      <ul className={styles.list}>
        {listItems.map((item, i) => (
          <li key={i}>
            <Text wrapper="span" type="body">
              {item}
            </Text>
          </li>
        ))}
      </ul>
      <Text wrapper="p" type="body">
        Whilst we process this request for you, we ask that you do not submit any new 1-2-1s or
        Performance Review prep to prevent duplicate records for a specific financial year or
        period.
      </Text>
      <Text wrapper="p" type="body">
        One of the team will be in touch to assist you.
      </Text>
    </Modal>
  );
};

export default LinkAccountsModal;
